import { useTranslation } from 'react-i18next'
import { Stepper, StepperProps, Step, StepLabel } from '@mui/material'

export const GrowerStepper = (stepperProps: StepperProps) => {
  const { t } = useTranslation('impact/GrowerStepper')

  return (
    <Stepper {...stepperProps} data-testid="grower-stepper">
      <Step key={'addFields'}>
        <StepLabel>{t('addFields')}</StepLabel>
      </Step>
      <Step key={'findProgramOpportunities'}>
        <StepLabel>{t('findProgramOpportunities')}</StepLabel>
      </Step>
      <Step key={'enrollFields'}>
        <StepLabel>{t('enrollFields')}</StepLabel>
      </Step>
    </Stepper>
  )
}
